import {
  GridFilterModel,
  GridPaginationModel,
  GridRowSelectionModel,
} from "@mui/x-data-grid-pro";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PaginationModel {
  page: number;
  pageSize: number;
}

interface PageState {
  paginationModel: PaginationModel;
  filterModel: GridFilterModel;
  selectedRows?: string[];
}

interface DmsDataGridProPageState {
  [contextID: string]: {
    paginationModel: PaginationModel;
    filterModel: GridFilterModel;
    rowSelectionModel?: GridRowSelectionModel;
    savedPageState: PageState | null;
  };
}

const initialState: DmsDataGridProPageState = {
  default: {
    paginationModel: { page: 0, pageSize: 5 },
    filterModel: { items: [] },
    rowSelectionModel: [],
    savedPageState: null,
  },
};

const dmsDataGridProPageSlice = createSlice({
  name: "dmsDataGridProPage",
  initialState,
  reducers: {
    // setRowsCount(state, action: PayloadAction<{ rowCount: number }>) {
    //   state.rowsCount = action.payload.rowCount
    // },
    setPaginationModel(
      state,
      action: PayloadAction<{
        contextId: string;
        paginationModel: PaginationModel;
      }>
    ) {
      const { contextId, paginationModel } = action.payload;
      if (!state[contextId]) {
        state[contextId] = { ...state.default }; // Inizializza un nuovo contesto se non esiste
      }
      state[contextId].paginationModel = paginationModel;
    },
    setFilterModel(
      state,
      action: PayloadAction<{ contextId: string; filterModel: GridFilterModel }>
    ) {
      const { contextId, filterModel } = action.payload;
      if (!state[contextId]) state[contextId] = state["default"];
      state[contextId].filterModel = filterModel;
    },
    setRowSelectionModel(
      state,
      action: PayloadAction<{
        contextId: string;
        rowSelectionModel: GridRowSelectionModel;
      }>
    ) {
      const { contextId, rowSelectionModel } = action.payload;
      if (!state[contextId]) state[contextId] = state["default"];
      state[contextId].rowSelectionModel = [...rowSelectionModel];
    },
    resetPage(state, action: PayloadAction<{ contextId: string }>) {
      const { contextId } = action.payload;
      state[contextId] = state["default"];
    },
  },
});

export const {
  setPaginationModel,
  setFilterModel,
  setRowSelectionModel,
  resetPage,
} = dmsDataGridProPageSlice.actions;

export default dmsDataGridProPageSlice.reducer;
